import actions from "./actions";

const initState = {

    vendorList: [],
    getVendorLoading: false,
    getVendorError: null,

    aCodeList: [],
    getACodeLoading: false,
    getACodeError: null,

    printDetailList: [],
    printDetailLoading: false,
    printDetailError: null,

    planList: [],
    getPlanLoading: false,
    getPlanError: null,

    billingCodeList: [],
    billingCodeLoading: false,
    billingCodeError: null,

    dashboardData: {},
    dashboardLoading: false,
    dashboardError: null,

    accessmenuList: [],
    accessmenuLoading: false,
    accessmenuError: null,

    UserPanelAccessList: [],
    getUserPanelAccessLoading: false,
    getUserPanelAccessError: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_VENDOR:
            return {
                ...state,
                vendorList: [],
                getVendorLoading: true,
                getVendorError: null,
            };
        case actions.GET_VENDOR_SUCCESS:
            return {
                ...state,
                vendorList: action.data,
                getVendorLoading: false,
                getVendorError: null,
            };
        case actions.GET_VENDOR_FAILED:
            return {
                ...state,
                getVendorLoading: false,
                getVendorError: action.error,
            }
        case actions.GET_ACODE:
            return {
                ...state,
                aCodeList: [],
                getACodeLoading: true,
                getACodeError: null,
            };
        case actions.GET_ACODE_SUCCESS:
            return {
                ...state,
                aCodeList: action.data,
                getACodeLoading: false,
                getACodeError: null,
            };
        case actions.GET_ACODE_FAILED:
            return {
                ...state,
                getACodeLoading: false,
                getACodeError: action.error,
            };

        case actions.PRINT_DETAILS:
            return {
                ...state,
                printDetailList: [],
                printDetailLoading: true,
                printDetailError: null,
            };

        case actions.PRINT_DETAILS_SUCCESS:
            return {
                ...state,
                printDetailList: action.data,
                printDetailLoading: false,
                printDetailError: null,
            };

        case actions.PRINT_DETAILS_FAILED:
            return {
                ...state,
                printDetailLoading: false,
                printDetailError: action.error,
            };

        case actions.GET_PLAN:
            return {
                ...state,
                planList: [],
                getPlanLoading: true,
                getPlanError: null,
            };
        case actions.GET_PLAN_SUCCESS:
            return {
                ...state,
                getPlanLoading: false,
                planList: action.result,
                getPlanError: null,
            };
        case actions.GET_PLAN_FAILED:
            return {
                ...state,
                getPlanLoading: false,
                getPlanError: action.error,
            };

        case actions.GET_BILLING_CODE:
            return {
                ...state,
                billingCodeList: [],
                billingCodeLoading: false,
                billingCodeError: null,
            };
        case actions.GET_BILLING_CODE_SUCCESS:
            return {
                ...state,
                billingCodeLoading: false,
                billingCodeList: action.result,
                billingCodeError: null,
            };
        case actions.GET_BILLING_CODE_FAILED:
            return {
                ...state,
                billingCodeLoading: false,
                billingCodeError: action.error,
            };


        case actions.GET_DASHBOARD:
            return {
                ...state,
                dashboardData: {},
                dashboardLoading: true,
                dashboardError: null,
            };
        case actions.GET_DASHBOARD_SUCCESS:
            return {
                ...state,
                dashboardLoading: false,
                dashboardData: action.result,
                dashboardError: null,
            };
        case actions.GET_DASHBOARD_FAILED:
            return {
                ...state,
                dashboardLoading: false,
                dashboardError: action.error,
            };

        case actions.GET_USER_PANEL_ACCESS:
            return {
                ...state,
                UserPanelAccessList: [],
                getUserPanelAccessLoading: true,
                getUserPanelAccessError: null,
            };

        case actions.GET_USER_PANEL_ACCESS_SUCCESS:
            return {
                ...state,
                getUserPanelAccessLoading: false,
                getUserPanelAccessError: null,
                UserPanelAccessList: action.payload.data,
            };

        case actions.GET_USER_PANEL_ACCESS_FAILED:
            return {
                ...state,
                getUserPanelAccessLoading: false,
                getUserPanelAccessError: action.error,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                printDetailList: [],
                printDetailError: null,
            };

        default:
            return state;
    }
}
